/* global rwgps, Routes */
import React from 'react'
import styles from './Surfaces.scss'
import { _TRouteSurfaces } from 'features/troute_show/TRouteShowPage/TRouteSidePanel/TRouteSurfaces'
import { Distance } from 'common/units'

export const Surfaces = ({ surfaceTypes, hoveredFeature, showSurfaceDebug }) => {
  if (!surfaceTypes || !rwgps.surfaces) {
    // ref doesn't exist yet
    return null
  }

  if (!Routes.activeMap?.activeRoute.showSurface) {
    // this route has no surface information on trackpoints, don't show surface breakdown
    return null
  }

  const { groupedSurfaces } = rwgps.surfaces
  // this is a reason to move map.routes and map.activeRoute state into the planner,
  // since this component is currently LegacyPlannerEngine specific
  const total = Routes.activeMap?.activeRoute.metrics.distance

  if (!showSurfaceDebug) {
    return <div key={total} className={styles.trouteSurfacesContainer}>
      <_TRouteSurfaces
        infoPlacement='bottom'
        surfaceTypes={surfaceTypes}
        groupedSurfaces={groupedSurfaces}
        totalDistance={total}
      />
    </div>
  }

  const { surfaces, roadClasses } = rwgps.surfaces

  return <>
    <ul className={styles.surfaces}>
      <li><label>surface from gh:</label> <span>{hoveredFeature?.surface !== undefined && surfaces[hoveredFeature.ghSurface]}</span></li>
      <li><label>surface:</label> <span>{hoveredFeature?.surface !== undefined && surfaces[hoveredFeature.surface]}</span></li>
      <li><label>highway:</label> <span>{hoveredFeature?.roadClass !== undefined && roadClasses[hoveredFeature.roadClass]}</span></li>
    </ul>
    {Object.keys(groupedSurfaces).map(group => <SurfaceGroup
      key={group}
      group={group}
      groupedSurfaces={groupedSurfaces}
      surfaceTypes={surfaceTypes}
      total={total}
    />)}
  </>
}

const SurfaceGroup = ({ group, groupedSurfaces, surfaceTypes, total }) => {
  const groupDist = Object.keys(groupedSurfaces[group]).reduce((acc, cur) => {
    if (surfaceTypes[cur]) {
      acc += surfaceTypes[cur]
    }
    return acc
  }, 0)

  return <div className={styles.surfaceGroup}>
    <div className={styles.totals}>
      <div className={styles.groupTitle}>{group}</div>
      <div><Distance value={groupDist} /></div>
      <div>{Math.round(groupDist / total * 100)}%</div>
    </div>
    <ul>
      {Object.entries(groupedSurfaces[group]).map(([surface, name]) => <SurfaceRow
        key={surface}
        surface={name}
        value={surfaceTypes[surface]}
        total={total}
      />)}
    </ul>
  </div>
}

const SurfaceRow = ({ surface, value, total }) => <li>
  <label>{surface}:</label>
  {value > 0 && <>
    <span><Distance bigUnits short value={value} /></span>
    <span>{Math.round(value / total * 100)}%</span>
  </>}
</li>
